import RpcBase from "@/utils/RpcBase";

export default class ViewBase extends RpcBase{
    constructor() {
        super();
        this.__metadata__ = null;
    }

    /** @returns {ExtendedPromise<String>}*/
    async getFkFieldLabel(fieldName, allowRemote = false) {
        if(this.__supplement__.fkLabels[fieldName] != null){
            let promise = new Promise( resolve => resolve(this.__supplement__.fkLabels[fieldName]));
            return RpcClass.extendPromise(promise);
        }
        // TODO
        return this.__getFkLabel(this.__metadata__[fieldName].remoteType, fieldName, allowRemote, false);
    }
}